let Events = require('f.core.event');
let md5 = require('./md5.js');
// console.log(md5)
let Native = {
    isApp: typeof grounds !== 'undefined'
};

let __index = 0;
let creatFun = function (callback) {
    const funName =
        '__grounds_' +
        Number(Math.floor(Math.random() * 10000000000)).toString(36) +
        __index++;
    window[funName] = function (msg) {
        callback(msg);
    };
    return funName;
};

let __Native = {
    intercall: (appCommand, callback) => {
        const funName = creatFun(callback);
        grounds[appCommand](funName);
    },

    on: (appCommand, callback) => {
        const funName = creatFun(callback);
        grounds.on(appCommand, funName);
    }
};

const formatUrl = function (url, params) {
    let urls = url.split('#');
    if (urls[0].indexOf('?') >= 0) {
        urls[0] = urls[0] + '&' + params;
    } else {
        urls[0] = urls[0] + '?' + params;
    }

    if (urls.length > 1) {
        return urls[0] + '#' + urls[1];
    } else {
        return urls[0];
    }
};

if (Native.isApp) {
    Object.assign(Native, {
        // App.on('networkchange', callback), 回调字符串, 值为, wifi, 2g, 3g, 4g, none, 其它情况算未知
        // 获取用户的上网环境
        network: new Promise((resolve, reject) => {
            __Native.on('networkchange', msg => {
                console.log(msg);
                resolve(msg);
                setTimeout(function () {
                    Native.trigger('networkchange', msg);
                }, 300);
            });
        }),
        // 获取用户的设备信息
        deviceInfo: new Promise((resolve, reject) => {
            __Native.intercall('deviceInfo', msg => {
                console.log(msg);
                resolve(msg);
            });
        }),
        freeflow: new Promise((resolve, reject) => {
            __Native.on('freeflow', msg => {
                console.log(msg);
                Native.trigger('freeflow', msg);
                resolve(msg);
            });
        }),
        // 拉起客户端登录界面
        userLogin: () => {
            grounds.userLogin();
        },
        // 最大化webview（仅ios有）
        maximization: () => {
            if (typeof grounds.maximization !== 'undefined') {
                grounds.maximization();
            }
        },
        // 退出最大化webview（仅ios有）
        exitMaximization: () => {
            if (typeof grounds.exitMaximization !== 'undefined') {
                grounds.exitMaximization();
            }
        },
        // 旋转webview
        // type 1 旋转到横屏 0 旋转到竖屏
        rotate: type => {
            grounds.rotate(type);
        },
        // 关闭
        close: () => {
            grounds.close();
        },
        // 获取用户信息
        getUserInfo: () => {
            return grounds.getUserInfo();
        },

        // 获取用户信息
        getDeviceInfo: () => {
            return grounds.getDeviceInfo();
        },
        // 调用客户端的分享功能
        // url, title, intro, pic, liveid
        openShare: (...arg) => {
            grounds.openShare(...arg);
        },
        openNative: id => {
            grounds.dispatch('text_live', id, '', '', '');
        },
        openH5: (id, mode, ref) => {
            grounds.dispatch(
                'web',
                `${window.location.protocol}//izhibo.ifeng.com/live.html?liveid=${id}&mode=${mode}&webkit=1&isFull=1&immersion=true&ref=${ref}`,
                '',
                '',
                ''
            );
        },
        openWeb: (url, sta) => {
            let paramStr = sta ? '' : 'webkit=1&isFull=0';
            url = formatUrl(url, paramStr);
            grounds.dispatch('web', url, '', '', '');
        },
        // 调用客户端的设置提醒功能
        // id, 直播间liveid
        // timeStamp, 需要弹出提醒的时间
        // title, 提示文字
        // type, 拉起直播间类型 h5_live（h5直播） | text_live（原生直播）
        setAlarmClock: (...arg) => {
            grounds.setAlarmClock(...arg);
        },
        sendlorder: id => {
            grounds.actionStat('{"type":"lorder","id":"live_sub_' + id + '"');
        },
        // 取消提醒，id为直播间liveid
        cancelAlarmClock: id => {
            grounds.cancelAlarmClock(id);
        },
        sendUnlorder: id => {
            grounds.actionStat('{"type":"lunorder","id":"live_sub_' + id + '"');
        },
        // 查询是否开启提醒
        isTiming: ids => {
            return new Promise((resolve, reject) => {
                let liveids = ids.split(',');
                const funName = creatFun(msg => {
                    const checks = msg.split(',');
                    let result = [];
                    for (let i = 0, iLen = checks.length; i < iLen; i++) {
                        if (checks[i] == 1) {
                            result.push(liveids[i]);
                        }
                    }
                    resolve(result);
                });
                grounds.isTiming(ids, funName);
            });
        },

        stat: (string, state) => {
            grounds.stat(string, state);
        },

        /**
         * 上报pv的接口
         * id: 当前页面id
         * ref: 表明页面是从哪里进入的，就直播频道来说，可以通过地址栏中ref参数获取，如果没有ref参数，就传空，
         * type: 页面类型，根据上方文档进行发送。
         */
        pageStat: (id, ref = '', type, showtype = '') => {
            grounds.pageStat(JSON.stringify({ id, ref, type, showtype }));
        },

        /**
         * 上报行为滚屏
         * type: upscreen，行为类型
         * id: 为当前页面id，规则见上方文档
         * psnum: 滚动的屏幕数（以scrolltop的高度除以屏幕高度，不满一屏的按一屏算）
         */
        actionStat: ({ type, id }, extend = {}) => {
            grounds.actionStat(
                JSON.stringify(Object.assign({ type, id }, extend))
            );
        },

        /**
         * 上报曝光数据
         * id: 为当前数据对应的页面的id （如果曝光的是直播里面中的直播，则为 piclive process=live | vlive process=video + liveid）
         * rnum: 数据所在位置，除精选外，其他列表都从1_1开始，依次为2_1，3_1，轮播图为1_1 1_2 1_3
         * reftype: 'editor'
         * ch: 为曝光数据所在的当前页面的id
         * src: 为曝光数据为直播时，src为所在的栏目，曝光数据是栏目时，src是什么呢，channel如何？
         */
        expose: (id, rumn, reftype, ch, src = '') => {
            grounds.expose(JSON.stringify({ id, rumn, reftype, ch, src }));
        },
        getShowMode: () => {
            return grounds.getShowMode();
        },

        /**
         * 通过native回调js的方法来实现在安卓下面视频的主动播放。
         * video可以是h5的video，也可以是一个有play方法的组件实例。
         */
        playVideo: (video, index) => {
            __Native.intercall('deviceInfo', () => {
                video.play(index);
            });
        },

        getAppName: () => {
            return grounds.getDeviceInfo().getProid();
        },

        loadFinish: () => {
            if (grounds.loadFinish) {
                grounds.loadFinish();
            }
        },

        syncSubscribe: ({ followid, type, isSubscribe }) => {
            if (
                grounds.syncSubscribe &&
                typeof grounds.syncSubscribe === 'function'
            ) {
                return grounds.syncSubscribe(followid, type, isSubscribe);
            } else {
                return false;
            }
        },

        getGuid: () => {
            return grounds.getUserInfo().getGuid();
        },

        getTokenAndTimestamp: liveId => {
            // "{时间前3位}{直播间id}_{用户guid}{时间后6位}"
            let guid = grounds.getUserInfo().getGuid();
            let timeStamp = Date.now() + '';
            let t3 = timeStamp.substr(0, 3) + '';
            let t6 = timeStamp.substr(4, 6) + '';

            let md5_string = t3 + liveId + '_' + guid + t6;

            let token = md5(md5(md5(md5_string)));
            let time = t3 + '' + t6;

            return { token, time };
        },

        storeReadHistory: liveInfo => {
            if (
                grounds.storeReadHistory &&
                typeof grounds.storeReadHistory === 'function'
            ) {
                grounds.storeReadHistory(JSON.stringify(liveInfo));
            }
        },

        getStatusBarHeight: () => {
            if (
                grounds &&
                grounds.getStatusBarHeight &&
                typeof grounds.getStatusBarHeight === 'function'
            ) {
                return grounds.getStatusBarHeight() / window.devicePixelRatio;
            }

            return 0;
        }
    });

    // 监听webview被挂起（一般是app被放到后台的情况下）
    __Native.on('exit', () => {
        Native.trigger('exit');
    });

    // 监听webview被激活
    __Native.on('active', () => {
        Native.trigger('active');
    });

    // 监听webview被销毁
    __Native.on('destory', () => {
        Native.trigger('destory');
    });

    // 监听webview划入划出
    if (grounds.slip) {
        __Native.intercall('slip', state => {
            console.log(2222222222, state);
            Native.trigger('slip', state);
        });
    }
}

Events.mixTo(Native);

export default Native;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.native/index.js